module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/08d123fea3812a6f7d9b4d7eb946b1b1.png";